import { NavLink, Outlet } from 'react-router-dom'

function BrandMark() {
  return (
    <span className="brand-mark" aria-hidden>
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M3 18 L10 6 L14 12 L17 7 L21 18 Z" fill="url(#bm)" opacity="0.95" />
        <circle cx="18" cy="5" r="2" fill="#5EC4E8" />
        <defs>
          <linearGradient id="bm" x1="3" y1="18" x2="21" y2="5" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1F8BB8" />
            <stop offset="0.5" stopColor="#2A9D8F" />
            <stop offset="1" stopColor="#7ED7F0" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  )
}

const tabs = [
  {
    to: '/',
    end: true,
    label: 'Home',
    desktop: 'Home',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M4 10.5 L12 4 l8 6.5 V19a1 1 0 0 1-1 1h-5v-5H10v5H5a1 1 0 0 1-1-1v-8.5z" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    to: '/mountains',
    label: 'Stamps',
    desktop: 'Stamps',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M4 18 L10 7 l3.5 5.5 L16 9 l4 9 H4z" strokeLinejoin="round" />
        <circle cx="17" cy="6" r="1.6" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    to: '/days',
    label: 'Days',
    desktop: 'Log days',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="4" y="5" width="16" height="15" rx="2.5" />
        <path d="M8 3v4M16 3v4M4 10h16" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    to: '/trips',
    label: 'Trips',
    desktop: 'Trips',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="9" cy="8" r="2.5" />
        <circle cx="16" cy="10" r="2.2" />
        <path d="M4.5 18c.8-2.4 2.6-3.6 4.5-3.6s3.7 1.2 4.5 3.6" strokeLinecap="round" />
        <path d="M13 18c.5-1.6 1.6-2.5 3-2.5 1.2 0 2.2.7 2.8 2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    to: '/season',
    label: 'Card',
    desktop: 'Season card',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3.5" y="5" width="17" height="14" rx="2.5" />
        <path d="M3.5 10h17" strokeLinecap="round" />
        <path d="M8 14h4" strokeLinecap="round" />
      </svg>
    ),
  },
]

export function Layout() {
  return (
    <div className="app-shell">
      <header className="topnav">
        <NavLink to="/" className="brand">
          <BrandMark />
          <span>Passfolio</span>
        </NavLink>
        <nav className="nav-links">
          {tabs.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end}>
              {t.desktop}
            </NavLink>
          ))}
        </nav>
      </header>

      <Outlet />

      <p className="footer-note">
        Passfolio · pass prices are public 2025–26 estimates for ROI only · not affiliated with Epic,
        Ikon, or Indy · your data stays in this browser unless you share a link
      </p>

      <nav className="bottom-nav" aria-label="Primary">
        <div className="bottom-nav-inner">
          {tabs.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end}>
              {t.icon}
              <span>{t.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  )
}
